<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cBMTUD/tc-custom/9781946578136.jpg?1706037166541" alt="This image is the cover for the book Triple Threat: Lucy Guardino Thrillers 1–3, Lucy Guardino FBI Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Triple Threat: Lucy Guardino Thrillers 1–3, Lucy Guardino FBI Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>New York Times–</i>bestselling author introduces a Glock-carrying soccer mom in the first three books in the Lucy Guardino FBI Thriller series.</b><br/>  <br/> She may be a loving mom and wife, but Lucy Guardino is also a kick-ass federal agent who’s not afraid to wield her skills in the series that’s “action packed, authentic, and intense” (Lee Child).<br/>  <br/><b><i>Snake Skin</i></b><br/>  <br/> Lucy Guardino is living the perfect life in Pittsburgh as a Supervisory Special Agent running the FBI’s Sexual Assault Felony Enforcement squad. Until the day she comes up against a vicious and cunning predator who forces Lucy to choose between the life of the young victim she is fighting to save and her own daughter’s . . .<br/>  <br/><b><i>Blood Stained</i></b><br/>  <br/> Ever since she fatally disobeyed orders, Lucy has been chained to her desk. But then she learns that a case she closed four years ago may have pinned a string of rapes and killings on the wrong man. Embarking on an unofficial investigation, she races to uncover truth—against a desperate boy out for vigilante justice.<br/>  <br/><b><i>Kill Zone</i></b><br/>  <br/> In one of <i>Suspense Magazine</i>’s Best Novels of the Year, the brutal killing of a teenage girl leads to a violent narcoterrorist turning the city into a kill zone. The girl’s father helped the DEA bring down drug cartels—and it seems someone holds a grudge. But Lucy soon learns that secrets hide in shadows . . .<br/>  <br/><b>Praise for CJ Lyons’ thrillers</b><br/>  <br/> “Pulse-pounding suspense and hair-raising chills.” —Susan Wiggs, #1 <i>New York Times</i>–bestselling author<br/>  <br/> “A compelling new voice in thriller writing.” —Jeffery Deaver, <i>New York Times</i>–bestselling author
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        CJ Lyons
      </h2>
      
      <p class="authorDescription body article">New York Times and USA Today bestselling author of over forty novels, former pediatric ER doctor CJ Lyons has lived the life she writes about in her cutting-edge Thrillers with Heart. CJ has been called a “master within the genre" (Pittsburgh Magazine) and her work has been praised as “breathtakingly fast-paced” and “riveting” (Publishers Weekly) with “characters with beating hearts and three dimensions” (Newsday). Her novels have twice won the International Thriller Writers’ prestigious Thriller Award, the RT Reviewers’ Choice Award, the Readers’ Choice Award, the RT Seal of Excellence, and the Daphne du Maurier Award for Excellence in Mystery and Suspense. Learn more about CJ’s Thrillers with Heart at www.CJLyons.net</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Edgy Reads
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e8ebc14a